import { Sidebar } from "../../common/Sidebar";
import { Navbar } from "../../common/Navbar";
import back from "../../../assets/svg/backArrow.svg";
import "../../common/Util.css";
import CommonDropdown from "../../common/common_dropDown";
import { Button, Spinner } from "react-bootstrap";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MoveLeft } from "lucide-react";
import { getProductDetailsApi } from "../../PurchaseOrder/po-api";
import deleteIcon from "../../../assets/svg/delete-po.svg";
import ErrorExtractor from "../../common/error_extractor";
import DOMPurify from "dompurify";
import DatePicker from "react-datepicker";
import { Calendar } from "lucide-react";
import {
  getProjectEditApi,
  submitProjectAPI,
  updateProjectAPI,
  getBudgetApi,
} from "./projectApi";

export const CreateProject = () => {
  const adminUrl = process.env.REACT_APP_ADMIN_API_URL;
  const apiUrl = process.env.REACT_APP_API_URL;
  const [isLoader, setIsLoader] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { id, isClone } = location.state || {};

  // Variable
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarStatus, setSnackbarStatus] = useState(false);
  const handleSnackbarShow = () => setShowSnackbar(true);
  const handleSnackbarClose = () => setShowSnackbar(false);
  const [productList, setProductList] = useState([]);
  const [budgets, setBudgets] = useState([]);
  const [nameValue, setNameValue] = useState("");
  const [codeValue, setCodeValue] = useState("");
  const [marginCost, setMarginCost] = useState("");
  const [projectValue, setProjectValue] = useState("");
  const [projectTotalValue, setProjectTotalValue] = useState("");
  const [project, setProject] = useState("");
  const [marginalPercentage, setMarginalPercentage] = useState("");
  const [adminOption, setAdminOption] = useState(null);
  const [managOption, setManagOption] = useState(null);
  const [proStageOption, setProStageOption] = useState(null);
  const [groupedError, setGroupedError] = useState({});
  const [removedProductList, setRemovedProductList] = useState([]);
  const [startDate, setStartDate] = useState();
  const [estimationDate, setEstimationDate] = useState();
  const [completionDate, setCompletionDate] = useState();
  const [claimedAmt, setClaimedAmt] = useState("");
  const [retentionAmt, setRetentionAmt] = useState("");
  const [retentionDueDate, setRetentionDueDate] = useState();
  const [retentionClaimAmt, setRetentionClaimAmt] = useState("");
  const [retentionClaimDate, setRetentionClaimDate] = useState();

  const [errorMsg, setErrorMsg] = useState({
    project_code: "",
    project_name: "",
    admin_id: "",
    manager_id: "",
  });
  //Common Function
  const getErrorMsg = (index, field) => {
    if (field === "product_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].product_id != null) {
          return (
            groupedError[index].product_id[0]?.replace(
              `products.${index}.product_id`,
              "product"
            ) ?? ""
          );
        }
      }
    }
    if (field === "unit_id") {
      if (groupedError[index] != null) {
        if (groupedError[index].unit_id != null) {
          return (
            groupedError[index].unit_id[0]?.replace(
              `products.${index}.unit_id`,
              "unit"
            ) ?? ""
          );
        }
      }
    }

    if (field === "qty") {
      if (groupedError[index] != null) {
        if (groupedError[index].qty != null) {
          return (
            groupedError[index].qty[0]?.replace(
              `products.${index}.qty`,
              "qty"
            ) ?? ""
          );
        }
      }
    }

    if (field === "amount") {
      if (groupedError[index] != null) {
        if (groupedError[index].amount != null) {
          return (
            groupedError[index].amount[0]?.replace(
              `products.${index}.amount`,
              "amount"
            ) ?? ""
          );
        }
      }
    }

    return "";
  };
  //Api
  const submitForm = async () => {
    setIsLoader(true);
    const extractor = new ErrorExtractor();

    try {
      const updatedData = productList.map((item) => ({
        ...item,
        product_id: item.product != null ? item.product.value : "",
        unit_id: item.unit != null ? item.unit.value : "",
        qty: item.quantity != null ? item.quantity : "",
        amount: item.amount != null ? item.amount : "",
      }));

      const preSanitizeData = {
        project_code: codeValue,
        project_name: nameValue,
        admin_id: adminOption?.value ?? "",
        manager_id: managOption?.value ?? "",
        stage_id: proStageOption?.value ?? "",
        project_cost: project,
        marginal_cost: marginCost,
        marginal_cost_percentage: marginalPercentage,
        estimated_date:
          estimationDate != null && estimationDate !== ""
            ? estimationDate.toLocaleDateString("en-CA")
            : "",
        start_date:
          startDate != null && startDate !== ""
            ? startDate.toLocaleDateString("en-CA")
            : "",
        completed_date:
          completionDate != null && completionDate !== ""
            ? completionDate.toLocaleDateString("en-CA")
            : "",
        products: updatedData,
        claimed_amount: claimedAmt,
        rentention_amount: retentionAmt,
        retention_due_date:
          retentionDueDate != null && retentionDueDate !== ""
            ? retentionDueDate.toLocaleDateString("en-CA")
            : "",
        rentention_claimed_amount: retentionClaimAmt,
        retention_claimed_date:
          retentionClaimDate != null && retentionClaimDate !== ""
            ? retentionClaimDate.toLocaleDateString("en-CA")
            : "",
        removed_products: removedProductList ?? [],
      };
      const sanitizedData = {};
      Object.entries(preSanitizeData).forEach(([key, value]) => {
        if (
          typeof value === "boolean" ||
          typeof value === "number" ||
          Array.isArray(value) ||
          key === "assignee"
        ) {
          sanitizedData[key] = value;
        } else {
          sanitizedData[key] = DOMPurify.sanitize(value);
        }
      });
      var response = null;
      if (id == null || isClone) {
        // 🔹 New project OR Clone → CREATE
        response = await submitProjectAPI(sanitizedData);
      } else {
        // 🔹 Existing project → UPDATE
        response = await updateProjectAPI(id, sanitizedData);
      }

      console.log("sdddd", response);
      // Check if response indicates failure
      if (response.status === 400) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);

          const validationTemp = {
            trans_type: "",
            vendor_id: "",
            project_id: "",
            po_id: "",
            amount: "",
            payment_type: "",
            description: "",
          };
          Object.entries(response.data.error).forEach(([key, value]) => {
            console.log(`${key}: ${value}`);
            validationTemp[key] = value.length === 0 ? "" : value[0];
          });
          console.log("validationTemp...", validationTemp);
          setErrorMsg(validationTemp);
        });
      } else if (response.data.success === true) {
        setSnackbarMessage(response.data.message);
        setSnackbarStatus(response.data.success);
        handleSnackbarShow();

        navigate(-1);
      }
    } catch (err) {
      console.error("Error submitting form:", err);

      // Optional: handle network errors separately
      if (
        err.response &&
        err.response.status === 400 &&
        err.response.data.error
      ) {
        new Promise((resolve, reject) => {
          const groupedErrorTemp = {};
          Object.entries(err.response.data.error).forEach(([key, value]) => {
            // match tickets.index.field
            const match = key.match(/^products\.(\d+)\.(.+)$/);

            if (match) {
              const index = match[1]; // e.g. "0"
              const field = match[2]; // e.g. "closing_date"

              if (!groupedErrorTemp[index]) groupedErrorTemp[index] = {};
              groupedErrorTemp[index][field] = value;
            }
          });
          setGroupedError(groupedErrorTemp);
        });
        const errorvalue = extractor.extractErrors(err.response.data, {
          ...errorMsg,
        });
        setErrorMsg(errorvalue);
      }
    } finally {
      setIsLoader(false);
    }
  };
  const getProductDetails = async (id, index) => {
    try {
      const response = await getProductDetailsApi(id);

      if (response.data.success === true) {
        const productDetail = response.data.product ?? {};
        const productTemp = [...productList];
        productTemp[index]["product_code"] = productDetail.code ?? "";
        productTemp[index]["product_img"] = productDetail.image ?? "";
        setProductList(productTemp);
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getProjectEdit = async (id) => {
    try {
      const response = await getProjectEditApi(id);

      if (response.data.success === true) {
        const projectDetail = response.data.project ?? {};
        setNameValue(projectDetail.name ?? "");
        setCodeValue(projectDetail.code ?? "");
        setMarginCost(projectDetail.marginal_cost ?? "");
        setProject(projectDetail.project_cost ?? "");
        setProjectTotalValue(projectDetail.product_amount ?? "");
        setMarginalPercentage(projectDetail.marginal_cost_percentage ?? "");
        setProStageOption({
          value: projectDetail.stage_id ?? "",
          label: projectDetail.stage ?? "",
        });
        setEstimationDate(
          projectDetail.estimated_date
            ? new Date(projectDetail.estimated_date)
            : null
        );
        setStartDate(
          projectDetail.start_date ? new Date(projectDetail.start_date) : null
        );
        setCompletionDate(
          projectDetail.completed_date
            ? new Date(projectDetail.completed_date)
            : null
        );
        setAdminOption({
          value: projectDetail.admin_value ?? "",
          label: projectDetail.admin_label ?? "",
        });
        setManagOption({
          value: projectDetail.manager_value ?? "",
          label: projectDetail.manager_label ?? "",
        });
        setClaimedAmt(projectDetail.claimed_amount ?? "");
        setRetentionAmt(projectDetail.rentention_amount ?? "");
        setRetentionDueDate(
          projectDetail.retention_due_date
            ? new Date(projectDetail.retention_due_date)
            : null
        );
        setRetentionClaimAmt(projectDetail.rentention_claimed_amount ?? "");
        setRetentionClaimDate(
          projectDetail.retention_claimed_date
            ? new Date(projectDetail.retention_claimed_date)
            : null
        );

        const productTemp = [];
        if (isClone) {
          projectDetail.products.forEach((item, index) => {
            productTemp.push({
              id: item.id,
              product: { value: item.product_value, label: item.product_label },
              product_code: item.code,
              unit: { value: item.unit_value, label: item.unit_label },
              quantity: item.qty,
              amount: item.amount,
            });
          });
          setProductList(productTemp);
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  // UseEffect

  useEffect(() => {
    if (id != null) {
      getProjectEdit(id);
    } else {
      setProductList([
        {
          id: 0,
          product: null,
          product_code: null,
          unit: null,
          quantity: 0,
          amount: 0,
        },
      ]);
    }
  }, [id]);
  // project value calculation
  useEffect(() => {
    const cost = parseFloat(project) || 0;
    const percentage = parseFloat(marginalPercentage) || 0;
    const calculatedMargin = (cost * percentage) / 100;
    const calculatedValue = cost - calculatedMargin;
    setMarginCost(calculatedMargin.toFixed(2));
    setProjectValue(calculatedValue.toFixed(2));
  }, [project, marginalPercentage]);

  // total product value
  useEffect(() => {
    const total = productList.reduce((acc, item) => {
      const amount = parseFloat(item.amount) || 0;
      return acc + amount;
    }, 0);
    setProjectTotalValue(total.toFixed(2));
  }, [productList]);

  return (
    <>
      <div className="d-flex">
        {/* Sidebar */}
        <Sidebar currentfile="Project" />
        {/* Main Content */}
        <div className="rounded-4 flex-grow-1">
          <div className="" style={{ backgroundColor: "#F5F8FA" }}>
            <Navbar pageTitle="Project" />
            <div
              className="d-flex bg-white align-items-center justify-content-between p-3"
              style={{ height: "64px" }}
            >
              <div className="d-flex align-items-center gap-3">
                <MoveLeft
                  className="cursor-pointer"
                  onClick={() => {
                    navigate(-1);
                  }}
                />
                <p className="m-0 fs-16 fw-600">
                  {isClone
                    ? "New project"
                    : id != null
                    ? "Update project"
                    : "New project"}
                </p>
              </div>
              <div className="d-flex gap-3">
                <button
                  onClick={() => {
                    navigate(-1);
                  }}
                  className="rounded-pill px-4 py-1 bg-transparent fs-15 fw-500 textcolor"
                  style={{ border: "1px solid #D4DDE7", height: "40px" }}
                >
                  Cancel
                </button>
                <button
                  className="backgroundPrimary rounded-pill px-4 py-1 text-white border-0 fs-15 fw-500 "
                  onClick={
                    isLoader
                      ? null
                      : () => {
                          submitForm();
                        }
                  }
                  style={{ height: "40px" }}
                >
                  {isLoader ? (
                    <Spinner animation="border" size="sm" />
                  ) : isClone ? (
                    "Save"
                  ) : id != null ? (
                    "Update"
                  ) : (
                    "Save"
                  )}
                </button>
              </div>
            </div>
            <div className="p-3">
              <div className="bg-white p-3 rounded-4">
                <p className="fs-16 fw-600">Project details</p>

                <div className="row align-items-start">
                  <div className="col-xl-2">
                    <label className="form-label d-flex fw-500 fs-13 mt-xl-4 my-2">
                      Code<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={codeValue || ""}
                      onChange={(e) => setCodeValue(e.target.value)}
                    />
                    <span className="error-txt fs-12 fw-500">
                      {errorMsg.project_code}
                    </span>
                  </div>

                  <div className="col-xl-2">
                    <label className="form-label d-flex fw-500 fs-13 mt-xl-4 my-2">
                      Name<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="text"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={nameValue || ""}
                      onChange={(e) => setNameValue(e.target.value)}
                    />
                    <span className="error-txt fs-12 fw-500">
                      {errorMsg.project_name}
                    </span>
                  </div>
                </div>

                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label d-flex fw-500 fs-13 mt-xl-4 my-2">
                      Admin<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonDropdown
                      apiUrl={`${adminUrl}get_employee`}
                      placeholder="Select"
                      className="w-100"
                      value={adminOption}
                      onSelect={(item) => setAdminOption(item)}
                    />
                    <span className="error-txt fs-12 fw-500">
                      {errorMsg.admin_id}
                    </span>
                  </div>

                  <div className="col-xl-2">
                    <label className="form-label d-flex fw-500 fs-13 mt-xl-4 my-2">
                      Manager<span className="error-text">*</span>
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonDropdown
                      apiUrl={`${adminUrl}get_employee`}
                      placeholder="Select"
                      className="w-100"
                      value={managOption}
                      onSelect={(item) => setManagOption(item)}
                    />
                    <span className="error-txt fs-12 fw-500">
                      {errorMsg.manager_id}
                    </span>
                  </div>
                </div>
                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Project Stage
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <CommonDropdown
                      apiUrl={`${apiUrl}get_project_stage`}
                      placeholder="Select"
                      className="w-100"
                      value={proStageOption}
                      onSelect={(item) => setProStageOption(item)}
                    />
                    <span className="error-txt fs-12 fw-500">
                      {errorMsg.manager_id}
                    </span>
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Project Cost
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={project}
                      onChange={(e) => setProject(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Marginal Percentage
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={marginalPercentage}
                      onChange={(e) => setMarginalPercentage(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Project Value
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Auto calculated"
                      value={projectValue}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Marginal Cost
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Auto calculated"
                      value={marginCost}
                      readOnly
                    />
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Product Total Value
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Auto calculated"
                      value={projectTotalValue || ""}
                      readOnly
                    />
                  </div>
                </div>

                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Start Date
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <DatePicker
                      selected={startDate}
                      onChange={(date) => setStartDate(date)}
                      dateFormat="yyyy-MM-dd"
                      // maxDate={new Date()}
                      customInput={
                        <button
                          style={{ color: "#8790A1", width: "100%" }}
                          className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                        >
                          {startDate ? (
                            startDate
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")
                          ) : (
                            <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>
                          )}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.start_date}
                    </span>
                  </div>

                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Estimation Date
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <DatePicker
                      selected={estimationDate}
                      onChange={(date) => setEstimationDate(date)}
                      dateFormat="yyyy-MM-dd"
                      // maxDate={new Date()}
                      customInput={
                        <button
                          style={{ color: "#8790A1", width: "100%" }}
                          className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                        >
                          {estimationDate ? (
                            estimationDate
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")
                          ) : (
                            <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>
                          )}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.estimation_date}
                    </span>
                  </div>
                </div>

                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Completion Date
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <DatePicker
                      selected={completionDate}
                      onChange={(date) => setCompletionDate(date)}
                      dateFormat="yyyy-MM-dd"
                      // maxDate={new Date()}
                      customInput={
                        <button
                          style={{ color: "#8790A1", width: "100%" }}
                          className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                        >
                          {completionDate ? (
                            completionDate
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")
                          ) : (
                            <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>
                          )}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.completion_date}
                    </span>
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Claimed Amount
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={claimedAmt}
                      onChange={(e) => setClaimedAmt(e.target.value)}
                    />
                  </div>
                </div>
                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Retention Amount
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={retentionAmt}
                      onChange={(e) => setRetentionAmt(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Retention Due Date
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <DatePicker
                      selected={retentionDueDate}
                      onChange={(date) => setRetentionDueDate(date)}
                      dateFormat="yyyy-MM-dd"
                      // maxDate={new Date()}
                      customInput={
                        <button
                          style={{ color: "#8790A1", width: "100%" }}
                          className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                        >
                          {retentionDueDate ? (
                            retentionDueDate
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")
                          ) : (
                            <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>
                          )}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.completion_date}
                    </span>
                  </div>
                </div>
                <div className="row align-items-start mt-2">
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Retention Claimed Amount
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <input
                      type="number"
                      className="form-control rounded-3 vendor-form-input"
                      placeholder="Enter here"
                      value={retentionClaimAmt}
                      onChange={(e) => setRetentionClaimAmt(e.target.value)}
                    />
                  </div>
                  <div className="col-xl-2">
                    <label className="form-label fw-500 fs-13 mt-xl-4 my-2">
                      Retention Claimed Date
                    </label>
                  </div>
                  <div className="col-xl-4 mt-xl-3">
                    <DatePicker
                      selected={retentionClaimDate}
                      onChange={(date) => setRetentionClaimDate(date)}
                      dateFormat="yyyy-MM-dd"
                      // maxDate={new Date()}
                      customInput={
                        <button
                          style={{ color: "#8790A1", width: "100%" }}
                          className="w-100 btn-border-grey form-control vehicle-form-input bg-white rounded-3 px-3 py-2 d-flex justify-content-between align-items-center gap-2"
                        >
                          {retentionClaimDate ? (
                            retentionClaimDate
                              .toLocaleDateString("en-GB")
                              .replace(/\//g, "-")
                          ) : (
                            <span style={{ color: "#8790A1" }}>dd-mm-yyyy</span>
                          )}
                          <Calendar size={16} />
                        </button>
                      }
                    />
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "start",
                        fontSize: "12px",
                        fontWeight: 400,
                        color: "#FF4444",
                        marginTop: "6px",
                        marginLeft: "6px",
                      }}
                    >
                      {errorMsg.completion_date}
                    </span>
                  </div>
                </div>
              </div>

              {((id == null && productList.length !== 0) || isClone) && (
                <div className="mt-4 bg-white rounded-4 p-3">
                  <div className="row">
                    <div className="col-12 ">
                      <div className="row">
                        <div className="col-xl-12">
                          <p className="fs-18 fw-600 mb-0">Product </p>
                        </div>
                        <div style={{ overflowY: "visible" }}>
                          <div className="mt-2 sticky-table-wrapper ">
                            <table
                              className="sticky-table"
                              border="1"
                              cellPadding="10"
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <thead
                                style={{
                                  height: "48px",
                                  backgroundColor: "#F2F2F2",
                                  color: "#212129",
                                  fontSize: "13px",
                                  fontWeight: "700",
                                  textAlign: "left",
                                }}
                              >
                                <tr>
                                  <th className="ps-2">Product Name</th>

                                  <th className="ps-2">Unit</th>
                                  <th className="ps-2">Quantity</th>
                                  <th className="ps-2">Amount</th>
                                  <th className="sticky-col"></th>
                                </tr>
                              </thead>
                              <tbody>
                                {productList.map((row, index) => (
                                  <tr key={row.id} style={{ height: "60px" }}>
                                    <td className="px-2 py-1">
                                      <CommonDropdown
                                        apiUrl={`${apiUrl}get_product?term=`}
                                        placeholder="Select"
                                        value={row.product}
                                        onSelect={(item) => {
                                          productList[index]["product"] = item;
                                          setProductList(productList);
                                        }}
                                      />
                                      <span
                                        style={{
                                          fontSize: "12px",
                                          fontWeight: 400,
                                          color: "#FF4444",
                                        }}
                                      >
                                        {getErrorMsg(index, "product_id")}
                                      </span>
                                    </td>

                                    <td className="px-2 py-1">
                                      <CommonDropdown
                                        apiUrl={`${apiUrl}get_uom?term=`}
                                        placeholder="Select"
                                        value={row.unit}
                                        onSelect={(item) => {
                                          productList[index]["unit"] = item;
                                          setProductList(productList);
                                        }}
                                      />
                                      <span className="fs-12 fw-500 cardTextRed">
                                        {getErrorMsg(index, "unit_id")}
                                      </span>
                                    </td>
                                    <td>
                                      <div
                                        className="mx-2"
                                        style={{ minWidth: "124px" }}
                                      >
                                        <input
                                          type="text"
                                          className="form-control rounded-3 vendor-form-input"
                                          id={`Quantity` + index}
                                          placeholder="Enter here"
                                          value={row.quantity}
                                          onChange={(e) => {
                                            const productTemp = [
                                              ...productList,
                                            ];
                                            productTemp[index]["quantity"] =
                                              e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");
                                            setProductList(productTemp);
                                          }}
                                        />

                                        <span className="fs-12 fw-500 cardTextRed">
                                          {getErrorMsg(index, "qty")}
                                        </span>
                                      </div>
                                    </td>
                                    <td>
                                      <div
                                        className="mx-2"
                                        style={{ minWidth: "124px" }}
                                      >
                                        <input
                                          type="text"
                                          className="form-control rounded-3 vendor-form-input"
                                          id={`Amount` + index}
                                          placeholder="Enter here"
                                          value={row.amount}
                                          onChange={(e) => {
                                            const productTemp = [
                                              ...productList,
                                            ];
                                            productTemp[index]["amount"] =
                                              e.target.value
                                                .replace(/[^0-9.]/g, "")
                                                .replace(/(\..*)\./g, "$1");
                                            setProductList(productTemp);
                                          }}
                                        />{" "}
                                      </div>
                                      <span className="fs-12 fw-500 cardTextRed">
                                        {getErrorMsg(index, "amount")}
                                      </span>
                                    </td>

                                    <td className="sticky-col">
                                      <div className="mx-2 ps-2 d-flex align-items-center">
                                        <img
                                          src={deleteIcon}
                                          alt="delete"
                                          style={{ cursor: "pointer" }}
                                          onClick={() => {
                                            if (
                                              row.id !== null &&
                                              row.id !== ""
                                            ) {
                                              setRemovedProductList([
                                                ...removedProductList,
                                                row.id,
                                              ]);
                                            }
                                            const productListTemp = [
                                              ...productList,
                                            ];
                                            productListTemp.splice(index, 1);
                                            setProductList(productListTemp);
                                          }}
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div className="col-xl-12 mt-2">
                          <Button
                            className={`cursor-pointer border-0 rounded-pill py-2 px-4 d-flex justify-content-center align-items-center`}
                            onClick={() => {
                              setProductList([
                                ...productList,
                                {
                                  id: 0,
                                  product: null,
                                  product_code: null,
                                  unit: null,
                                  quantity: 0,
                                  amount: 0,
                                },
                              ]);
                            }}
                            style={{
                              minWidth: "100px",
                              background: "#E6E4FF",
                              color: "#212129",
                              fontWeight: "600",
                              fontSize: "13px",
                            }}
                          >
                            Add product
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
